import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MarqueeTicker from "./components/MarqueeTicker";
import Products from "./components/Products";
import WhyMerai from "./components/WhyMerai";
import DemoForm from "./components/DemoForm";
import Footer from "./components/Footer";
import GenAIPage from "./pages/GenAIPage";

const LandingPage = () => {
  return (
    <div data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <MarqueeTicker />
        <Products />
        <WhyMerai />
        <DemoForm />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/gen-ai-at-scale" element={<GenAIPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
